import React from 'react';

export default function EnterGate({ onEnter }) {
  return (
    <div
      onClick={onEnter}
      style={{
        position: 'fixed',
        inset: 0,
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 100000,
      }}
    >
      <style>{`
        @keyframes gate-pulse {
          0%, 100% {
            box-shadow:
              0 0 40px 10px rgba(30, 90, 255, 0.35),
              0 0 90px 30px rgba(30, 90, 255, 0.18),
              inset 0 0 60px rgba(30, 90, 255, 0.12);
          }
          50% {
            box-shadow:
              0 0 60px 18px rgba(30, 90, 255, 0.55),
              0 0 140px 50px rgba(30, 90, 255, 0.28),
              inset 0 0 90px rgba(30, 90, 255, 0.2);
          }
        }
        @keyframes gate-text-glow {
          0%, 100% { text-shadow: 0 0 20px rgba(60,120,255,0.6), 0 0 50px rgba(60,120,255,0.3); }
          50% { text-shadow: 0 0 32px rgba(60,120,255,0.9), 0 0 80px rgba(60,120,255,0.5); }
        }
        .gate-ring {
          width: 220px;
          height: 220px;
          border-radius: 50%;
          border: 1.5px solid rgba(60, 130, 255, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          animation: gate-pulse 2.8s ease-in-out infinite;
        }
        .gate-text {
          font-family: 'Orbitron', monospace;
          font-size: 22px;
          font-weight: 900;
          letter-spacing: 0.35em;
          color: #eaf2ff;
          animation: gate-text-glow 2.8s ease-in-out infinite;
          padding-left: 0.35em;
        }
      `}</style>
      <div className="gate-ring">
        <span className="gate-text">ENTER</span>
      </div>
    </div>
  );
}
